import React from "react"

import { type IconProps } from "./utils"

export default function FileTextIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 3.75C3 2.50736 4.00736 1.5 5.25 1.5H9.12868C9.72542 1.5 10.2977 1.73705 10.7197 2.15901L10.4687 2.40996L10.7197 2.15901L14.341 5.78033C14.7629 6.20229 15 6.77458 15 7.37132V14.25C15 15.4926 13.9926 16.5 12.75 16.5H5.25C4.00736 16.5 3 15.4926 3 14.25V3.75ZM9 3H5.25C4.83579 3 4.5 3.33579 4.5 3.75V14.25C4.5 14.6642 4.83579 15 5.25 15H12.75C13.1642 15 13.5 14.6642 13.5 14.25V7.5H11.25C10.0074 7.5 9 6.49264 9 5.25V3ZM12.4393 6H11.25C10.8358 6 10.5 5.66421 10.5 5.25V4.06066L12.4393 6ZM6 9.75C6 9.33579 6.33579 9 6.75 9H9C9.41421 9 9.75 9.33579 9.75 9.75C9.75 10.1642 9.41421 10.5 9 10.5H6.75C6.33579 10.5 6 10.1642 6 9.75ZM6 12.75C6 12.3358 6.33579 12 6.75 12H11.625C12.0392 12 12.375 12.3358 12.375 12.75C12.375 13.1642 12.0392 13.5 11.625 13.5H6.75C6.33579 13.5 6 13.1642 6 12.75Z"
        fill="currentColor"
      />
    </svg>
  )
}
